/**
 * One completed advice in a client order list: a collapsible card whose
 * header reads "<flow> · completed <date> … N orders" — shared by the Orders,
 * Recurring orders and Mandate orders tabs. The body is the tab's own detail.
 */

export const T = {
  en_GB: { completed: "completed" },
  nb_NO: { completed: "fullført" },
} as const;
